export const name = 'DemoModeController';
export default function DemoModeController(
  $window,
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let interval = null;

  /* jshint validthis: true */
  let vm = this;
  vm.loading = true;

  vm.close = close;
  vm.unitTest = {};

  vm.$onInit = onInit;
  ////////////////

  function onInit() {
    interval = setInterval(keepAlive, 15 * 60 * 1000);
    document.title = 'PrintOS Demo Mode';
    vm.loading = false;
  }

  function keepAlive() {
    $window.$printos.http.v1.get('aaa', 'organizations', {version: 4});
  }

  function close() {
    $window.close();
  }
}
